import fs from "node:fs/promises";
import os from "node:os";
import path from "node:path";
import {Browser, chromium, Page} from "playwright";
import {afterAll, beforeAll, describe, expect, it} from "vitest";
import {applyPageConfig, genPageConfig, readPageConfig} from "./config-manager.js";

// NOTE: This is an integration test that requires a running AI Studio instance.
// For now, we will mock the browser execution part.
// In a real CI/CD environment, we would use Playwright to run these tests against a live page.

describe.skip("Config Manager (Integration)", () => {
  let tempDir: string;
  let browser: Browser;
  let page: Page;

  beforeAll(async () => {
    tempDir = await fs.mkdtemp(path.join(os.tmpdir(), "jixo-config-test-"));
    browser = await chromium.launch();
    page = await browser.newPage();
    await page.goto("https://aistudio.google.com/"); // Navigate to a page where the scripts can run
  });

  afterAll(async () => {
    await fs.rm(tempDir, {recursive: true, force: true});
    await browser.close();
  });

  it("should generate a default config file", async () => {
    const sessionId = "test-session-gen";
    await genPageConfig({sessionId, workDir: tempDir});
    const configPath = path.join(tempDir, `${sessionId}.config.json`);
    const content = JSON.parse(await fs.readFile(configPath, "utf-8"));

    expect(content).toHaveProperty("model");
    expect(content).toHaveProperty("systemPrompt");
    expect(content).toHaveProperty("tools");
  });

  // This test requires mocking the 'execa' call or running in a fully interactive environment.
  // We'll write the structure, but it will be skipped in automated runs for now.
  it.skip("should read config from the page and save it", async () => {
    const sessionId = "test-session-read";
    // Here you would mock the executeBrowserScript to return a specific config
    const config = await readPageConfig({sessionId, workDir: tempDir});
    expect(config).toHaveProperty("model");

    const configPath = path.join(tempDir, `${sessionId}.config.json`);
    expect(await fs.stat(configPath)).toBeDefined();
  });

  it.skip("should apply a local config to the page", async () => {
    const sessionId = "test-session-apply";
    const configPath = path.join(tempDir, `${sessionId}.config.json`);
    const testConfig = {
      model: "gemini-1.5-pro-latest",
      systemPrompt: "You are a test assistant.",
      tools: [],
    };
    await fs.writeFile(configPath, JSON.stringify(testConfig));

    // Mock executeBrowserScript to verify it's called with the correct script
    await applyPageConfig({sessionId, workDir: tempDir});
    // Assertions would go here to check if the correct browser functions were called.
  });
});
